import React from 'react';
import { format, isToday, isYesterday, isThisWeek, parseISO } from 'date-fns';

interface DateHeaderProps {
  date: string | Date;
  isSticky?: boolean;
}

export function DateHeader({ date, isSticky = false }: DateHeaderProps) {
  const formatDateLabel = (date: string | Date) => {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    
    if (isToday(dateObj)) {
      return 'Today';
    }
    
    if (isYesterday(dateObj)) {
      return 'Yesterday';
    }
    
    if (isThisWeek(dateObj)) {
      return format(dateObj, 'EEEE'); // Monday, Tuesday, etc.
    }
    
    return format(dateObj, 'MMMM dd, yyyy'); // January 15, 2024
  };

  return (
    <div className={`
      flex justify-center py-2 
      ${isSticky ? 'sticky top-0 z-20 bg-gray-50/80 backdrop-blur-sm border-b border-border/20' : ''}
    `}>
      <div className="bg-white/90 text-muted-foreground text-xs px-3 py-1 rounded-full shadow-sm border border-border/20">
        {formatDateLabel(date)}
      </div>
    </div>
  );
}